import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useFieldArray, useForm, useWatch } from 'react-hook-form';
import FieldsDatePicker from '../../../../../@casino/ui/Fields/DatePicker';
import FieldInput from '../../../../../@casino/ui/Fields/Input';
import FieldTextarea from '../../../../../@casino/ui/Fields/Textarea';
import { useDispatch } from 'react-redux';
import { setPostMailing } from '../../../../store/mailing/thunk/setPostMailing';
import FieldSelect from '../../../../../@casino/ui/Fields/Select';
import { setPostPinsale } from '../../../../store/requestApi/thunk/pinsale/thunk/setPostPinsale';

const useStyles = makeStyles(() => ({
    root: {
        position: 'fixed',
        top: 0,
        left: 0,
        background: 'rgba(0,0,0,0.2)',
        height: '100vh',
        width: '100vw',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000000,
    },
    form: {
        background: '#1c2542',
        borderRadius: 8,
        padding: 20,
        display: 'flex',
        flexDirection: 'column',
        rowGap: '12px',
        minWidth: 500,
        maxHeight: 1050,
        overflowY: 'scroll'
    },
    field: {
        padding: 10,
        paddingLeft: 10,
        border: '1px solid #141b33',
        outline: 'none',
        margin: 10,
        color: '#000',
        width: 'calc(100% - 40px)',
        '&::placeholder': {
            color: '#000'
        }
    },
    btn: {
        padding: '8px 14px',
        borderRadius: 4,
        background: 'gold',
        color: '#000',
        cursor: 'pointer',
        border: 'none',
        fontSize: 18
    },
    btn_disabled: {
        padding: '8px 13px',
        borderRadius: 4,
        background: 'none',
        color: '#ACACAC',
        border: '1px solid gold',
        cursor: 'pointer',
        fontSize: 18
    }
}))

const ModalCreatePinsale = ({
    handleChangeMode,
}) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const {
        register,
        control,
        handleSubmit,
        reset
    } = useForm({
        defaultValues: {
            count_days: "",
            details: [{
                deposit_min: '',
                deposit_max: '',
                bonus: '',
                wager: ''
            }]
        }
    })

    const onSubmit = (store) => {
        dispatch(setPostPinsale(store, handleCancel));
    }

    const [from_date, to_date, bonus_type, max_activate, count_bonus, game_uuid, pinsale] = useWatch({
        control,
        name: ['from_date', 'to_date', 'bonus_type', 'max_activate', 'count_bonus', 'game_uuid', 'pinsale']
    });

    const {fields, append, remove} = useFieldArray({
        control,
        name: 'details'
    })

    const handleCancel = () => {
        handleChangeMode();
        reset({})
    }

    const isValid = false;

    return (
        <div className={classes.root}>
            <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
                <div style={{ display: 'flex', flexDirection: 'column', rowGap: 12 }}>
                    <FieldsDatePicker
                        register={register}
                        type="date"
                        label="Период действия"
                    />
                    <FieldSelect
                        register={register}
                        label="Тип бонуса"
                        name="bonus_type"
                        list={[{
                            label: 'Фриспины',
                            value: 'fs'
                        }, {
                            label: 'Бонусные деньги',
                            value: 'cash'
                        }, {
                            label: 'Фриспины за депозит',
                            value: 'fs_deposit'
                        }, {
                            label: '% за депозит',
                            value: 'cash_percent_deposit'
                        }, {
                            label: 'Фиксированный бонус за депозит',
                            value: 'cash_fix_deposit'
                        }]}
                        defaultOption="Выбрать тип бонуса"
                    />

                    <FieldInput
                        name="pinsale"
                        placeholder="Пинсейл код"
                        type="number"
                        register={register}
                    />
                    {
                        bonus_type && fields?.map((item, key) => (
                            <div>
                                <span style={{
                                    whiteSpace: 'nowrap',
                                    overflow: 'visible',
                                    textOverflow: 'ellipsis',
                                    position: 'relative',
                                    display: 'inline-block',
                                    fontSize: '11px',
                                    color: 'hsla(0,0%,100%,.7)',
                                    marginBottom: '4px',
                                    verticalAlign: 'middle',
                                    fontFamily: "PT Sans, sans-serif",
                                    userSelect: 'none'
                                }}>Условие №{key + 1}</span>
                                <div style={{paddingLeft: 10, display: 'flex', flexDirection: 'column', rowGap: 10, paddingTop: 10}}>
                                    <FieldSelect
                                        register={register}
                                        label="Валюта"
                                        name={`details[${key}].currency`}
                                        list={[{
                                            value: 'RUB',
                                            label: 'RUB',
                                        }, {
                                            value: 'KZT',
                                            label: 'KZT',
                                        }, {
                                            label: 'UZS',
                                            value: 'UZS',
                                        }, {
                                            label: 'TRY',
                                            value: 'TRY',
                                        }, {
                                            label: 'GEL',
                                            value: 'GEL'
                                        }, {
                                            label: 'USD',
                                            value: 'USD'
                                        }, {
                                            label: 'EUR',
                                            value: 'EUR'
                                        }, {
                                            label: 'INR',
                                            value: 'INR'
                                        }]}
                                        defaultOption="Выбрать валюту"
                                    />
                                    <FieldInput
                                        name={`details[${key}].max_activate`}
                                        placeholder="Максимальное количество активаций"
                                        type="number"
                                        register={register}
                                    />
                                    {
                                        bonus_type !== 'cash' && bonus_type !== 'fs' && (
                                            <>
                                                <FieldInput
                                                    name={`details[${key}].deposit_min`}
                                                    placeholder="Мин. депозит"
                                                    type="number"
                                                    register={register}
                                                />
                                                <FieldInput
                                                    name={`details[${key}].deposit_max`}
                                                    placeholder="Макс. депозит"
                                                    type="number"
                                                    register={register}
                                                />
                                            </>
                                        )
                                    }
                                    {
                                        (bonus_type === 'fs' || bonus_type === 'fs_deposit') && (
                                            <FieldInput
                                                name={`details[${key}].game_uuid`}
                                                placeholder={"UUID игры"}
                                                register={register}
                                            />
                                        )
                                    }
                                    <FieldInput
                                        name={`details[${key}].bonus`}
                                        placeholder={bonus_type === 'cash_percent_deposit' ? "Бонус в % от депозита" : bonus_type === 'fs' || bonus_type === 'fs_deposit' ? "Количество фс" : "Бонус"}
                                        type="number"
                                        register={register}
                                    />
                                    
                                    <FieldInput
                                        name={`details[${key}].wager`}
                                        placeholder="Wager x"
                                        type="number"
                                        register={register}
                                    />
                                </div>
                            </div>
                        ))
                    }
                    {
                        bonus_type && (
                            <span style={{
                                whiteSpace: 'nowrap',
                                overflow: 'visible',
                                textOverflow: 'ellipsis',
                                position: 'relative',
                                display: 'inline-block',
                                fontSize: '11px',
                                color: 'hsla(0,0%,100%,.7)',
                                marginBottom: '4px',
                                verticalAlign: 'middle',
                                fontFamily: "PT Sans, sans-serif",
                                userSelect: 'none',
                                cursor: 'pointer'
                            }} onClick={() => {append({deposit_min: '', deposit_max: '', bonus: '', wager: ''})}}>+ Добавить условие</span>
                        )
                    }
                    
                </div>
                <div style={{ display: 'flex', columnGap: 12, justifyContent: 'flex-end' }}>
                    <button
                        type="button"
                        onClick={handleCancel}
                        className={classes.btn_disabled}
                    >
                        Отменить
                    </button>
                    <button
                        type="submit"
                        disabled={isValid}
                        className={!isValid ? classes.btn : classes.btn_disabled}
                    >
                        Создать
                    </button>
                </div>
            </form>
        </div>
    )
}

export default ModalCreatePinsale;